import React from 'react';

import { PointDistribution } from './components/PointDistribution';
import { PointParamsSetting } from './components/PointParamsSetting';
import { ServicePointsTable } from './components/ServicePointsTable';
import styles from './index.module.scss';

export const PointRecordList = () => {
  return (
    <div className={styles.pageContent}>
      <ServicePointsTable />
      <PointParamsSetting />
      <PointDistribution />
    </div>
  );
};
